import { useState, useRef, useEffect } from "react";
import Sider from "../../comps/sider/main";
import style from "./main.css"
import {List,Tabs,Radio,Checkbox, Popconfirm, Rate, Alert, Avatar, Skeleton,Typography, Card, message, Col, Row, Statistic, Tooltip, Empty, Button, Collapse, Popover, Divider, Modal, Segmented, Tag, Drawer, Space, Input, Upload, InputNumber, Select, Switch, Progress, Form } from "antd";

import { useEditor, EditorProvider, FloatingMenu, BubbleMenu } from '@tiptap/react'



import StarterKit from '@tiptap/starter-kit'
import Underline from '@tiptap/extension-underline'
import Link from '@tiptap/extension-link'
import Youtube from '@tiptap/extension-youtube'
import Heading from '@tiptap/extension-heading'
import { EditorContent } from '@tiptap/react'


import UploadFileToS3 from "../../funcs/s3Upload";
import { v4 as uuidv4 } from 'uuid';
import ReactPlayer from 'react-player'

import {
    CheckOutlined,
    CloseOutlined,
    MenuOutlined,
    BoldOutlined,
    ItalicOutlined,
    UnderlineOutlined,
    FontSizeOutlined,
    LinkOutlined,
    YoutubeOutlined,
    PlusOutlined,
    MinusCircleOutlined,
    PlusCircleOutlined,
    MinusOutlined,
    UploadOutlined,
    InboxOutlined,
    PictureOutlined,
    CopyOutlined,
    FolderAddOutlined,
    DollarOutlined,
    TwitterOutlined,
    InstagramFilled,
    LinkedinOutlined,
    LinkedinFilled,
    YoutubeFilled,
    EditOutlined,
    DeleteOutlined,
    GlobalOutlined,
    CheckCircleOutlined
} from '@ant-design/icons'

import {
  DragDropContext,
  Droppable,
  Draggable,
} from "react-beautiful-dnd";


const { Text } = Typography;
const MenuBar = ({ editor }) => {
    const [isLinkModalOpen, setLinkModalOpen] = useState(false)
    const [isYTModalOpen, setYTModalOpen] = useState(false)
    const [linkUrl, setLinkUrl] = useState('')
    const [ytUrl, setYTUrl] = useState('')

    if (!editor) return null

    const insertLink = () => {
        if (linkUrl) {
            editor.chain().focus().setLink({ href: linkUrl }).run()
            setLinkModalOpen(false)
            setLinkUrl('')
        }
    }

    const insertYT = () => {
        if (ytUrl) {
            editor.chain().focus().setYoutubeVideo({ src: ytUrl }).run()
            setYTModalOpen(false)
            setYTUrl('')
        }
    }

    return (
        <>
            <div className="menu-bar">
                <Space>
                    <Tooltip title="Bold">
                        <Button
                            type={editor.isActive('bold') ? 'primary' : 'default'}
                            icon={<BoldOutlined />}
                            onClick={() => editor.chain().focus().toggleBold().run()}
                        />
                    </Tooltip>

                    <Tooltip title="Italic">
                        <Button
                            type={editor.isActive('italic') ? 'primary' : 'default'}
                            icon={<ItalicOutlined />}
                            onClick={() => editor.chain().focus().toggleItalic().run()}
                        />
                    </Tooltip>

                    <Tooltip title="Underline">
                        <Button
                            type={editor.isActive('underline') ? 'primary' : 'default'}
                            icon={<UnderlineOutlined />}
                            onClick={() => editor.chain().focus().toggleUnderline().run()}
                        />
                    </Tooltip>

                    <Tooltip title="Heading 2">
                        <Button
                            type={editor.isActive('heading', { level: 2 }) ? 'primary' : 'default'}
                            icon={<FontSizeOutlined />}
                            onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()}
                        />
                    </Tooltip>

                    <Tooltip title="Insert Link">
                        <Button icon={<LinkOutlined />} onClick={() => setLinkModalOpen(true)} />
                    </Tooltip>

                    <Tooltip title="Embed YouTube">
                        <Button icon={<YoutubeOutlined />} onClick={() => setYTModalOpen(true)} />
                    </Tooltip>
                </Space>
            </div>

            {/* Link Modal */}
            <Modal
                title="Insert Link"
                open={isLinkModalOpen}
                onOk={insertLink}
                onCancel={() => setLinkModalOpen(false)}
                okText="Insert"
            >
                <Input
                    placeholder="https://example.com"
                    value={linkUrl}
                    onChange={(e) => setLinkUrl(e.target.value)}
                />
            </Modal>

            {/* YouTube Modal */}
            <Modal
                title="Embed YouTube Video"
                open={isYTModalOpen}
                onOk={insertYT}
                onCancel={() => setYTModalOpen(false)}
                okText="Embed"
            >
                <Input
                    placeholder="https://www.youtube.com/watch?v=xyz"
                    value={ytUrl}
                    onChange={(e) => setYTUrl(e.target.value)}
                />
            </Modal>
        </>
    )
}


const RichEditor = ({ data, onChange }) => {

    

    const editor = useEditor({
        extensions: [
            StarterKit,
            Underline,
            Link.configure({
                openOnClick: false,
            }),
            Youtube.configure({
                width: 640,
                height: 360,
            }),
            Heading.configure({
                levels: [1, 2, 3],
            }),
        ],
        content: data || "Click to add description, youtube video, link to platfrom and more.",
        onUpdate: ({ editor }) => {
            onChange?.(editor.getHTML())
        },
    })


    return (
        <div className="editor-wrapper">
            <MenuBar editor={editor} />
            <EditorContent editor={editor} />
        </div>
    )
}

const { TextArea } = Input;



function FaqSection({faqs, setFaqs}) {
    // const [faqs, setFaqs] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [question, setQuestion] = useState('');
    const [answer, setAnswer] = useState('');
    const [editingIndex, setEditingIndex] = useState(null);
  
    const resetModal = () => {
      setQuestion('');
      setAnswer('');
      setEditingIndex(null);
    };
  
    const handleAddOrUpdate = () => {
      const updatedFaq = { question, answer };
  
      if (editingIndex !== null) {
        const updated = [...faqs];
        updated[editingIndex] = updatedFaq;
        setFaqs(updated);
      } else {
        setFaqs([...faqs, updatedFaq]);
      }
  
      setIsModalOpen(false);
      resetModal();
    };
  
    const handleEdit = (index) => {
      setEditingIndex(index);
      setQuestion(faqs[index].question);
      setAnswer(faqs[index].answer);
      setIsModalOpen(true);
    };
  
    const handleDelete = (index) => {
      const updated = [...faqs];
      updated.splice(index, 1);
      setFaqs(updated);
    };
  
    return (
      <div>
        <p>FAQ</p>
        <Button type="dashed" icon={<PlusOutlined />} onClick={() => setIsModalOpen(true)}>
          Add FAQ
        </Button>
  
        <div style={{ marginTop: 16, display: 'flex', flexDirection: 'column', gap: 12 }}>
          {faqs.map((faq, index) => (
            <div className="faq-card" key={index}>
              
                
                    <Collapse items={[  {
                        key: '1',
                        label: faq.question,
                        children: <div> <p>{faq.answer}</p>

                        <div className="faq-actions">
                            <Button size="small" type="text" onClick={() => handleEdit(index)}>
                            <EditOutlined/>
                            </Button>
                            <Button size="small" type="text" danger onClick={() => handleDelete(index)}>
                            <DeleteOutlined/>
                            </Button>
                        </div>
                        
                         </div>
                        
                        }]} />
                  
                </div>
              
            
          ))}
        </div>
  
        <Modal
          title={editingIndex !== null ? 'Edit FAQ' : 'Add FAQ'}
          open={isModalOpen}
          onOk={handleAddOrUpdate}
          onCancel={() => {
            setIsModalOpen(false);
            resetModal();
          }}
          okText={editingIndex !== null ? 'Update' : 'Add'}
        >
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <Input
              placeholder="Enter question"
              value={question}
              onChange={(e) => setQuestion(e.target.value)}
            />
            <TextArea
              rows={3}
              placeholder="Enter answer"
              value={answer}
              onChange={(e) => setAnswer(e.target.value)}
            />
          </div>
        </Modal>
      </div>
    );
  }


function TestimonialsSection({testimonials, setTestimonials}) {
    const socialOptions = [
        { label: <p><TwitterOutlined style={{ color: "skyblue" }} /> Twitter</p>, value: 'Twitter' },
        { label: <p><InstagramFilled style={{ color: "violet" }} /> Instagram</p>, value: 'Instagram' },
        { label: <p><LinkedinFilled style={{ color: "blue" }} /> LinkedIn</p>, value: 'LinkedIn' },
        { label: <p><YoutubeFilled style={{ color: "red" }} /> Youtube</p>, value: 'YouTube' },
    ];
    const [isModalOpen, setIsModalOpen] = useState(false);
    // const [testimonials, setTestimonials] = useState([]);
    const [profilePicFile, setProfilePicFile] = useState(null);
    const [social, setSocial] = useState('');
    const [name, setName] = useState('');
    const [review, setReview] = useState('');
    const [rating, setRating] = useState(5);

    const [uploadStatus, setUploadStatus] = useState(0)

    const [editingIndex, setEditingIndex] = useState(null);


    const resetModal = () => {
        setProfilePicFile(null);
        setSocial('');
        setName('');
        setReview('');
        setRating(0);
        setEditingIndex(null);
    };


    const handleAdd = () => {
        const updatedTestimonial = {
            name,
            review,
            social,
            rating,
            profilePicUrl: null,
        };

        const applyUpdate = (finalUrl = null) => {
            updatedTestimonial.profilePicUrl = finalUrl;

            if (editingIndex !== null) {
                const updated = [...testimonials];
                updated[editingIndex] = updatedTestimonial;
                setTestimonials(updated);
            } else {
                setTestimonials([...testimonials, updatedTestimonial]);
            }

            setIsModalOpen(false);
            setProfilePicFile(null)
            resetModal();
        };

        applyUpdate(profilePicFile ? `${profilePicFile}` : null)

    };


    const handleDelete = (index) => {
        const updated = [...testimonials];
        updated.splice(index, 1);
        setTestimonials(updated);
    };

    const handleEdit = (index) => {
        const t = testimonials[index];
        
        setName(t.name);
        setReview(t.review);
        setSocial(t.social);
        setRating(t.rating);
        setProfilePicFile(t.profilePicUrl);
        setEditingIndex(index);
        setIsModalOpen(true);
    };



    return (
        <div>
            <p>Testimonials</p>
            <Button type="dashed" icon={<PlusOutlined />} onClick={() => setIsModalOpen(true)}>
                Add Testimonial
            </Button>

            <div className="testimonial-cards">
                {testimonials.map((t, idx) => (
                    <div className="testimonial-card" key={idx}>
                        <Card size="small">
                            <Space align="start">
                                <Avatar src={t.profilePicUrl} />
                                <div style={{ flex: 1 }}>
                                    <strong>{t.name}</strong> — {t.social}
                                    <div>
                                        <Rate disabled defaultValue={t.rating} />
                                    </div>
                                    <p style={{ margin: 0 }}>{t.review}</p>
                                    <div className="testimonial-actions">
                                        <Button
                                            type="text"
                                            size="small"
                                            onClick={() => handleEdit(idx)}
                                        >
                                            <EditOutlined />
                                        </Button>
                                        <Button
                                            type="text"
                                            size="small"
                                            danger
                                            onClick={() => handleDelete(idx)}
                                        >
                                            <DeleteOutlined />
                                        </Button>
                                    </div>
                                </div>

                            </Space>
                        </Card>
                    </div>
                ))}
            </div>

            <Modal
                title="Add Testimonial"
                open={isModalOpen}
                onOk={handleAdd}
                onCancel={() => {
                    setIsModalOpen(false);
                    resetModal();
                }}
                okText="Add"
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                    <div>
                        <label>Profile Picture</label>
                        <Upload
                            beforeUpload={(file) => {
                                // setProfilePicFile(file);
                                return false; // prevent auto-upload
                            }}
                            maxCount={1}
                            onChange={({ file }) => {
                                handleMediaUpload({file, "product_id":"some-id","uploadStatus":setUploadStatus, setURL: (url) => {setProfilePicFile((prev) => ( url ))}} ) }
                            }
                            listType="picture"
                            fileList={
                            profilePicFile
                              ? [
                                  {
                                    uid: '-1',
                                    name: 'Profile Picture',
                                    status: 'done',
                                    url: profilePicFile,
                                  },
                                ]
                              : []
                          }

                           onRemove={() => {
                              setProfilePicFile(null);
                            }}
                        >
                            <Button icon={<UploadOutlined />}>Upload</Button>
                        </Upload>
                    </div>

                    <div>
                        <label>Social Media</label>
                        <Select
                            options={socialOptions}
                            value={social}
                            onChange={setSocial}
                            placeholder="Select platform"
                            style={{ width: '100%' }}
                        />
                    </div>

                    <div>
                        <label>Reviewer Name</label>
                        <Input
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            placeholder="e.g. John Doe"
                        />
                    </div>

                    <div>
                        <label>Review</label>
                        <TextArea
                            rows={3}
                            value={review}
                            onChange={(e) => setReview(e.target.value)}
                            placeholder="Write the review here..."
                        />
                    </div>
                    <div>
                        <label>Rating</label>
                        <Rate value={rating} onChange={setRating} />
                    </div>
                </div>
            </Modal>
        </div>
    );
}


function CourseBenefits({benefits, setBenefits}) {
    // const [benefits, setBenefits] = useState(['']);

    const handleChange = (index, value) => {
        const updated = [...benefits];
        updated[index] = value;
        setBenefits(updated);
    };

    const handleAdd = () => {
        setBenefits([...benefits, '']);
    };

    const handleRemove = (index) => {
        const updated = benefits.filter((_, i) => i !== index);
        setBenefits(updated);
    };

    return (
        <div style={{ width: '100%' }}>
            <p>Course Benefits</p>
            <Space direction="vertical" style={{ width: '100%' }}>
                {benefits.map((benefit, index) => (
                    <div key={index} style={{ display: 'flex', gap: 8 }}>
                        <Input
                            placeholder={`Benefit ${index + 1}`}
                            value={benefit}
                            onChange={(e) => handleChange(index, e.target.value)}
                            style={{ flex: 1 }}
                        />
                        {benefits.length > 1 && (
                            <MinusCircleOutlined onClick={() => handleRemove(index)} style={{ color: 'red', marginTop: 8 }} />
                        )}
                    </div>
                ))}
                <Button block type="dashed" onClick={handleAdd} icon={<PlusOutlined />}>
                    Add Benefit
                </Button>
            </Space>
        </div>
    );
}


const handleMediaUpload = async ({file, product_id,messageApi, uploadStatus,setURL}) => {
    
    
    let media_id = uuidv4();//generate random id;
    let media_type = file.name.split('.').pop(); //get media type from file
    let url = await UploadFileToS3(messageApi,file, product_id,media_id,media_type, uploadStatus);
    if(setURL){
        setURL(url)
    }
    return url
}   

function CourseSyllabus({modules,setModules}) {
    // const [modules, setModules] = useState([]);
  
    // Module modal
    const [isModuleModalOpen, setIsModuleModalOpen] = useState(false);
    const [newModuleName, setNewModuleName] = useState('');
  
    // Lesson modal
    const [isLessonModalOpen, setIsLessonModalOpen] = useState(false);
    const [currentModuleIndex, setCurrentModuleIndex] = useState(null);
    const [messageApi, contextHolder] = message.useMessage();

    const [showAdvanceOptions, setShowAdvanceOption] = useState(false)
    const [lessonData, setLessonData] = useState({
      name: '',
      videoLink: '',
      videoFile: null,
      isFreePreview: false,
      description: '',
      material: null,
    });

    const [editingLessonIndex, setEditingLessonIndex] = useState(null);
    const [editingModuleIndex, setEditingModuleIndex] = useState(null);

  
    const resetLessonData = () => {
      setLessonData({
        name: '',
        videoLink: '',
        videoFile: null,
        isFreePreview: false,
        description: '',
        material: null,
      });
      setShowAdvanceOption(false)
    };
  

    const handleAddModule = () => {
      if (newModuleName.trim() === '') return;
      
      if (editingModuleIndex !== null) {
        const modulesToEdit = modules[editingModuleIndex]
        modulesToEdit.name = newModuleName

      }
      else{
        setModules([...modules, { name: newModuleName, lessons: [] }]);
      }      
      setNewModuleName('');
      setIsModuleModalOpen(false);
    };
  


    const [uploadStatus, setUploadStatus] = useState(0);

    const openLessonModal = (moduleIdx, lessonIdx = null) => {
        setCurrentModuleIndex(moduleIdx);
        if (lessonIdx !== null) {
          const lessonToEdit = modules[moduleIdx].lessons[lessonIdx];
          setLessonData({ ...lessonToEdit });
          setEditingLessonIndex(lessonIdx);
          setShowAdvanceOption(false);
        } else {
          resetLessonData();
          setEditingLessonIndex(null);
        }
        setIsLessonModalOpen(true);
      };
      

    const handleAddLesson = () => {
        if (lessonData.name.trim() === '') return;
      
        const updatedModules = [...modules];
        if (editingLessonIndex !== null) {
          // Edit existing lesson
          updatedModules[currentModuleIndex].lessons[editingLessonIndex] = { ...lessonData };
        } else {
          // Add new lesson
          updatedModules[currentModuleIndex].lessons.push({ ...lessonData });
        }
      
        setModules(updatedModules);
        setIsLessonModalOpen(false);
        resetLessonData();
        setEditingLessonIndex(null);
      };

      
    const handleDeleteLesson = (moduleIdx, lessonIdx) => {
        const updatedModules = [...modules];
        updatedModules[moduleIdx].lessons.splice(lessonIdx, 1);
        setModules(updatedModules);
      };

      const handleDeleteChapter = (moduleIdx) => {
        const updatedModules = [...modules];
        updatedModules.splice(moduleIdx, 1);
        setModules(updatedModules);
      };


  
    return (
      <div>
        <div style={{display:"flex", flexDirection:"row", justifyContent:"space-between", alignContent:"center" , justifyItems:"center", alignItems:"center"}}>
        <p>Course Syllabus</p>
        <Button color="default" variant="outlined" icon={<PlusOutlined />} onClick={() => setIsModuleModalOpen(true)}>
          Add Chapter
        </Button>
        </div>
  
        <div style={{ marginTop: 16, display: 'flex', flexDirection: 'column', gap: 16 }}>
          {modules.map((module, idx) => (
            <Card
              key={idx}
              title={module.name}
              extra={
                <Space>
                
                <Popconfirm title="Are you sure you want to delete it?" onConfirm={() => handleDeleteChapter(idx)} > <Button color="default" variant="text"> <DeleteOutlined style={{color:"red"}}/> </Button> </Popconfirm>
                <Button color="default"  variant="text" 
                onClick={() => {
                    setNewModuleName(module.name)
                    setEditingModuleIndex(idx)
                    setIsModuleModalOpen(true)
                }}
                > <EditOutlined/> </Button>
                

                <Button size="small" type="link" onClick={() => openLessonModal(idx)}>
                  <PlusOutlined/> Lesson
                </Button>
                </Space>
              }
            >
              {module.lessons.length === 0 && <Empty title="No Lessons" description={"No lessons yet."}></Empty>}
              {module.lessons.map((lesson, i) => (
                    <Card
                        size="small"
                        key={i}
                        style={{ marginBottom: 8 }}
                        actions={[
                        <Button size="small" type="link" onClick={() => openLessonModal(idx, i)}>Edit</Button>,
                        <Popconfirm title="Are you sure you want to delete it?" onConfirm={() => handleDeleteLesson(idx, i)} ><Button size="small" type="link" danger >Delete</Button></Popconfirm>
                        ]}
                    >
                        <strong>{lesson.name}</strong> {lesson.isFreePreview ? '⭐ Free Preview' : ''}
                    </Card>
                    ))}




            </Card>
          ))}
        </div>
  
        {/* Module Modal */}
        <Modal
          open={isModuleModalOpen}
          onCancel={() => {setIsModuleModalOpen(false); setEditingModuleIndex(null);setNewModuleName('');  }}
          onOk={handleAddModule}
          title= { editingModuleIndex != null ? "Edit Chapter" :  "Add Chapter"}
        >
            
          <Input
            placeholder="Chapter name"
            value={newModuleName}
            onChange={(e) => setNewModuleName(e.target.value)}
          />
        </Modal>
  
        {/* Lesson Modal */}
        <Modal
          open={isLessonModalOpen}
          onCancel={() => setIsLessonModalOpen(false)}
          onOk={handleAddLesson}
          title="Add Lesson"
        >
          <Space direction="vertical" style={{ width: '100%' }}>
            <h3>Lesson name</h3>
            <Input
              placeholder="Lesson name"
              value={lessonData.name}
              onChange={(e) => setLessonData({ ...lessonData, name: e.target.value })}
            />

            
          {!lessonData.videoLink &&   <Upload
              beforeUpload={(file) => {
                setLessonData({ ...lessonData, custom_upload:true});
                return false;
              }}
              maxCount={1}
              onChange={({ file }) => {
                setLessonData({ ...lessonData, url : handleMediaUpload({file, "product_id":"some-id",messageApi,"uploadStatus":setUploadStatus,  setURL : (url) => { setLessonData({ ...lessonData,videoLink:url }) }} ) }) } 
            }
            >
              <Button icon={<UploadOutlined />} block color="purple" variant="outlined">Upload Video</Button>
              <p style={{color:"rgba(0,0,0,.4)", textAlign:"center", margin:"0 auto", marginTop:"10px"}}>No size Limit</p>
            </Upload>
            }
            
            { (uploadStatus > 0 && uploadStatus < 100) && <Progress percent={uploadStatus}/> }

            {!lessonData.videoLink &&   <Divider>or paste video link</Divider> }

           { !lessonData.custom_upload && <Input
            prefix={<GlobalOutlined style={{color:"blue"}}/>}
              placeholder="Youtube or video link"
              value={lessonData.videoLink}
              onChange={(e) => setLessonData({ ...lessonData, videoLink: e.target.value })}
            /> }
            
           {lessonData.videoLink && <ReactPlayer  style={{maxWidth:"100%"}} controls url={lessonData.videoLink} /> }
           {
                lessonData.videoLink && <Button block color="danger" variant="solid" onClick={() => {setLessonData({ ...lessonData, custom_upload:undefined, videoLink: ""});}}>Remove Video</Button>
            }
            <Divider/>
            {
             !showAdvanceOptions ?  <Button type="dashed" block onClick={() => {setShowAdvanceOption(true)}}>Show Advance option</Button> :  <>
            
            <h3>Description</h3>
            <RichEditor data={lessonData.description} onChange = { (description)=> { setLessonData({ ...lessonData, description: description })}}  />
            <h3>Upload Supporting Material</h3>
            <Upload
              beforeUpload={(file) => {
                setLessonData({ ...lessonData, material: file });
                return false;
              }}
              maxCount={1}
            >
              <Button color="pink" variant="outlined" icon={<UploadOutlined />} block>Upload Pdf, Docs, Images (50 MB Max)</Button>
            </Upload>
            <div style={{ marginBottom:"0px", width:"100%",display:"flex", flexDirection:"row", alignItems:"center", justifyContent:"space-between"}}>
            <h3>Free Lesson</h3>
            <Switch
              checked={lessonData.isFreePreview}
              onChange={(value) =>
                setLessonData({ ...lessonData, isFreePreview: value })
              }
            >
              
            </Switch>
            </div>
            <p style={{marginTop:"-14px", opacity:".4"}}>Include this as free lesson for preview</p>
            <Button onClick={() => {setShowAdvanceOption(false)}} block>Hide Advance option</Button>
            </>
            }
          </Space>
        </Modal>
      </div>
    );
  }


  const { Option } = Select;

function ValiditySelector({validity, setValidity}) {

  
  if(validity === undefined || setValidity === undefined){
    return <></>
  }
  
    return (
      <div>
        <p>Course Validity</p>
        <Radio.Group
        block
          onChange={(e) => { setValidity( { ...validity , type: e.target.value }) }}
          value={validity.type}
          optionType="button" 
        >
          
            <Radio value="lifetime">Lifetime Access</Radio>
            <Radio value="limited">Limited Access</Radio>
          
        </Radio.Group>

        
  
        {validity.type === 'limited' && (
            <>
          <div style={{marginTop:"10px"}}>
            <InputNumber
              min={1}
              value={validity.limitValue}
              style={{width:"48%", marginRight:"2%"}}
              onChange={(val) => setValidity({ ...validity, limitValue: val })}
            />
            <Select
              value={validity.limitUnit}
              onChange={(val) => setValidity({ ...validity, limitUnit: val })}
              style={{width:"50%"}}
            >
              <Option value="days">Days</Option>
              <Option value="months">Months</Option>
            </Select>

          </div>
          <p>Students can access the content for only <b>{validity.limitValue} {validity.limitUnit}</b> from the date of purchase. </p>
          </>
        )}
      </div>
    );
  }
  

  function PricingSection({ pricing, setPricing }) {
    
  
    return (
      <div>
        <p>Pricing</p>
  
        <Radio.Group
          value={pricing.pricingType}
          onChange={(e) => setPricing({...pricing, pricingType :e.target.value})}
          optionType="button" 
          block
        >
            <Radio value="fixed">Fixed Price</Radio>
            <Radio value="student">User Decide Price</Radio>
        </Radio.Group>
  
  
        {pricing.pricingType === 'fixed' && (
          <Space direction="vertical" size="middle" style={{ width: '100%' }}>
            <div>
              <p>Regular Price</p>
              <InputNumber
                min={0}
                style={{ width: '100%' }}
                value={pricing.regularPrice}
                onChange={(e) =>setPricing({...pricing, regularPrice: e || 0})}
                prefix="₹"
              />
            </div>
  
            <div>
              <p>Offer Price</p>
              <InputNumber
                min={0}
                style={{ width: '100%' }}
                value={pricing.offerPrice}
                onChange={(e) =>setPricing({...pricing, offerPrice: e || 0})}
                prefix="₹"
              />
            </div>
  
            {/* <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <Switch checked={gstEnabled} onChange={setGstEnabled} />
              <span>Include GST (18%)</span>
            </div> */}
          </Space>
        )}
  
        {pricing.pricingType === 'student' && (
          <Space direction="vertical" size="middle" style={{ width: '100%' }}>
            <div>
              <p>Minimum Price</p>
              <InputNumber
                min={0}
                style={{ width: '100%' }}
                value={pricing.minPrice}
                onChange={(e) =>setPricing({...pricing, minPrice: e || 0})}
                prefix="₹"
              />
            </div>
  
            <div>
              <p>Suggested Price</p>
              <InputNumber
                min={0}
                style={{ width: '100%' }}
                value={pricing.suggestedPrice}
                onChange={(e) =>setPricing({...pricing, suggestedPrice: e || 0})}
                prefix="₹"
              />
            </div>
          </Space>
        )}
      </div>
    );
  }


  const StudentFieldsManager = ({customFields,setCustomFields}) => {

  // const [customFields, setCustomFields] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [form] = Form.useForm();

  const handleOTPChange = (index, checked) => {
    const updated = [...customFields];
    updated[index].verifyWithOTP = checked;
    setCustomFields(updated);
  };

  const handleDelete = (index) => {
    const updated = [...customFields];
    updated.splice(index, 1);
    setCustomFields(updated);
  };

  const handleAddField = (values) => {
    const newField = {
      label: values.label.trim(),
      type: values.type,
      options: values.options || [],
      isDefault: false,
    };
    setCustomFields([...customFields, newField]);
    form.resetFields();
    setIsModalVisible(false);
  };

    const onDragEnd = (result) => {
    if (!result.destination) return;
    const reordered = [...customFields];
    const [moved] = reordered.splice(result.source.index, 1);
    reordered.splice(result.destination.index, 0, moved);
    setCustomFields(reordered);
  };


  return (
    <div>
      <Text strong>Student Fields:</Text>

    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="fields">
        {(provided) => (
          <List
            bordered
            style={{ marginTop: 12 }}
            ref={provided.innerRef}
            {...provided.droppableProps}
            dataSource={customFields}
            renderItem={(item, index) => {
              const isCustom = !item.isDefault;
              const showOTP = ["email", "mobile"].includes(item.label.toLowerCase());

              return (
                <Draggable
                  draggableId={item.label + index}
                  index={index}
                  key={item.label + index}
                >
                  {(provided, snapshot) => (
                    <List.Item
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      style={{
                        ...provided.draggableProps.style,
                        background: snapshot.isDragging ? "#fafafa" : "white",
                      }}
                      actions={
                        [
                              <Popconfirm
                                title="Delete this field?"
                                onConfirm={() => handleDelete(index)}
                                okText="Yes"
                                cancelText="No"
                              >
                                <DeleteOutlined />
                              </Popconfirm>,

                           showOTP &&
                              <Space>
                                <span>Verify via OTP</span>
                                <Switch
                                  checked={item.verifyWithOTP}
                                  onChange={(checked) =>
                                    handleOTPChange(index, checked)
                                  }
                                />
                              </Space>,
                            ]
                          
                      }
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 12,
                          width: "100%",
                        }}
                      >
                        <div
                          {...provided.dragHandleProps}
                          style={{ cursor: "grab" }}
                        >
                          <MenuOutlined style={{opacity:".4"}} />
                        </div>
                        <Space direction="vertical" style={{ width: "100%" }}>
                          <Text strong>{item.label}</Text>
                          <Text type="secondary">
                            Type: <Tag color="blue">{item.type}</Tag>
                          </Text>
                        </Space>
                      </div>
                    </List.Item>
                  )}
                </Draggable>
              );
            }}
          />
        )}
      </Droppable>
    </DragDropContext>

      <Button
        icon={<PlusOutlined />}
        type="primary"
        style={{ marginTop: 16 }}
        onClick={() => setIsModalVisible(true)}
      >
        Add Field
      </Button>

      <Modal
        title="Add Custom Field"
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
      >
        <Form form={form} layout="vertical" onFinish={handleAddField}>
          <Form.Item
            label="Field Label"
            name="label"
            rules={[{ required: true, message: 'Please enter field name' }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Field Type"
            name="type"
            rules={[{ required: true, message: 'Please select field type' }]}
          >
            <Select placeholder="Select a type">
              <Option value="text">Text</Option>
              <Option value="dropdown">Dropdown (Single choice)</Option>
              <Option value="checkbox">Checkbox (Multiple choices)</Option>
            </Select>
          </Form.Item>

          <Form.Item shouldUpdate={(prev, curr) => prev.type !== curr.type}>
            {() => {
              const fieldType = form.getFieldValue('type');
              if (fieldType === 'dropdown' || fieldType === 'checkbox') {
                return (
                  <Form.Item
                    label="Options"
                    name="options"
                    rules={[
                      {
                        required: true,
                        message: 'Please provide at least one option',
                      },
                    ]}
                  >
                    <Select
                      mode="tags"
                      placeholder="Enter options and press enter"
                      tokenSeparators={[',']}
                    />
                  </Form.Item>
                );
              }
              return null;
            }}
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" block>
              Add Field
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

  
const DiscountCoupons = ({coupons, setCoupons}) => {
    // const [coupons, setCoupons] = useState([]);
    const [form] = Form.useForm();
    const [isModalVisible, setIsModalVisible] = useState(false);
  
    const handleAddCoupon = (values) => {
      const code = values.code.trim().toUpperCase();
      if (coupons.some((c) => c.code === code)) {
        Modal.error({
          title: 'Duplicate Coupon',
          content: 'This coupon code already exists. Try another code.',
        });
        return;
      }
  
      const newCoupon = {
        code,
        type: values.type,
        value: values.value,
      };
      setCoupons([...coupons, newCoupon]);
      form.resetFields();
      setIsModalVisible(false);
    };
  
    const handleDelete = (index) => {
      const updated = [...coupons];
      updated.splice(index, 1);
      setCoupons(updated);
    };
  
    return (
      <div style={{ marginTop: 24 }}>
        <Text strong>Discount Coupons:</Text>
  
        <List
          bordered
          style={{ marginTop: 12 }}
          dataSource={coupons}
          renderItem={(item, index) => (
            <List.Item
              actions={[
                <Popconfirm
                  title="Delete this coupon?"
                  onConfirm={() => handleDelete(index)}
                  okText="Yes"
                  cancelText="No"
                >
                  <DeleteOutlined />
                </Popconfirm>,
              ]}
            >
              <Space direction="vertical" style={{ width: '100%' }}>
                <Text strong>
                  {item.code}{' '}
                  <Tag color={item.type === 'percent' ? 'blue' : 'green'}>
                    {item.type === 'percent' ? `${item.value}%` : `₹${item.value}`}
                  </Tag>
                </Text>
              </Space>
            </List.Item>
          )}
        />
  
        <Button
          icon={<PlusOutlined />}
          type="primary"
          style={{ marginTop: 16 }}
          onClick={() => setIsModalVisible(true)}
        >
          Add Coupon
        </Button>
  
        <Modal
          title="Add Discount Coupon"
          open={isModalVisible}
          onCancel={() => setIsModalVisible(false)}
          footer={null}
        >
          <Form form={form} layout="vertical" onFinish={handleAddCoupon}>
            <Form.Item
              label="Coupon Code"
              name="code"
              rules={[{ required: true, message: 'Please enter a coupon code' }]}
            >
              <Input placeholder="E.g. SAVE10" />
            </Form.Item>
  
            <Form.Item
              label="Discount Type"
              name="type"
              rules={[{ required: true, message: 'Please select discount type' }]}
            >
              <Select placeholder="Select type">
                <Option value="percent">Percent (%)</Option>
                <Option value="amount">Fixed Amount (₹)</Option>
              </Select>
            </Form.Item>
  
            <Form.Item
              label="Discount Value"
              name="value"
              rules={[{ required: true, message: 'Enter discount value' }]}
            >
              <InputNumber
                min={1}
                max={10000}
                style={{ width: '100%' }}
                placeholder="E.g. 10 or 500"
              />
            </Form.Item>
  
            <Form.Item>
              <Button type="primary" htmlType="submit" block>
                Add Coupon
              </Button>
            </Form.Item>
          </Form>
        </Modal>
      </div>
    );
  };
  
  const PoliciesManager = ({policies, setPolicies}) => {
  
    const [modalVisible, setModalVisible] = useState(false);
    const [currentKey, setCurrentKey] = useState('');
    const [currentValue, setCurrentValue] = useState('');
  
    const policyLabels = {
      terms: 'Terms & Conditions',
      refund: 'Refund Policy',
      privacy: 'Privacy Policy',
    };
  
    const handleOpenModal = (key) => {
      setCurrentKey(key);
      setCurrentValue(policies[key]);
      setModalVisible(true);
    };
  
    const handleSave = () => {
      let new_polices = {...policies}
      new_polices[currentKey] = currentValue
      setPolicies(new_polices);
      setModalVisible(false);
     
    };
  
    return (
      <div style={{ marginTop: 24 }}>
        <Text strong>Policies:</Text>
  
        <List
          bordered
          style={{ marginTop: 12 }}
          dataSource={Object.entries(policyLabels)}
          renderItem={([key, label]) => (
            <List.Item
              actions={[
                <Button type="link" onClick={() => handleOpenModal(key)}>
                  {policies[key] ? 'Update' : 'Set'} Policy
                </Button>,
              ]}
            >
              <Space direction="vertical">
                <Text strong>{label}</Text>
              </Space>
            </List.Item>
          )}
        />
  
        <Modal
          title={policyLabels[currentKey]}
          open={modalVisible}
          onCancel={() => setModalVisible(false)}
          onOk={handleSave}
          okText="Save"
        >
          <TextArea
            rows={10}
            value={currentValue}
            onChange={(e) => setCurrentValue(e.target.value)}
            placeholder={`Enter ${policyLabels[currentKey]?.toLowerCase()} here...`}
          />
        </Modal>
      </div>
    );
  };


const AddEditAuthorModal = ({ visible, onCreate, onCancel, initialValues }) => {
  const [form] = Form.useForm();
  const [profilePicFile, setProfilePicFile] = useState(null);
  const [uploadStatus, setUploadStatus] = useState(0);

  const normFile = (e) => (Array.isArray(e) ? e : e?.fileList);

  useEffect(() => {
    if (visible && initialValues) {
      const imageUrl = initialValues.imageUrl || null;
      setProfilePicFile(imageUrl);

      const fileList = imageUrl
        ? [
            {
              uid: "-1",
              name: "image.png",
              status: "done",
              url: imageUrl,
              thumbUrl: imageUrl,
            },
          ]
        : [];

      form.setFieldsValue({
        ...initialValues,
        image: fileList,
      });
    } else {
      form.resetFields();
      setProfilePicFile(null);
    }
  }, [visible, initialValues, form]);

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        const imageUrl =
          profilePicFile ||
          values.image?.[0]?.thumbUrl ||
          initialValues?.imageUrl ||
          null;

        form.resetFields();
        setProfilePicFile(null);

        onCreate({ ...values, imageUrl });
      })
      .catch(() => {
        message.error("Please fix the errors before submitting.");
      });
  };

  return (
    <Modal
      open={visible}
      title={initialValues ? "Edit Author" : "Add Author"}
      okText={initialValues ? "Update" : "Add"}
      cancelText="Cancel"
      onCancel={() => {
        form.resetFields();
        setProfilePicFile(null);
        onCancel();
      }}
      onOk={handleOk}
      width={600}
    >
      <Form form={form} layout="vertical" name="author_form_modal">
        <Form.Item
          label="Upload Image"
          name="image"
          valuePropName="fileList"
          getValueFromEvent={normFile}
        >
          <Upload
            listType="picture"
            maxCount={1}
            beforeUpload={() => false} // prevent auto upload
            onChange={({ file }) => {
              handleMediaUpload({
                file,
                product_id: "some-id",
                uploadStatus: setUploadStatus,
                setURL: (url) => setProfilePicFile(url),
              });
            }}
            fileList={
              profilePicFile
                ? [
                    {
                      uid: "-1",
                      name: "Profile Picture",
                      status: "done",
                      url: profilePicFile,
                    },
                  ]
                : []
            }
            onRemove={() => {
              setProfilePicFile(null);
              form.setFieldsValue({ image: [] });
            }}
          >
            <Button icon={<UploadOutlined />}>Upload Image</Button>
          </Upload>
        </Form.Item>

        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true, message: "Please enter the name" }]}
        >
          <Input placeholder="Author Name" />
        </Form.Item>

        <Form.Item
          label="Description"
          name="description"
          rules={[{ required: true, message: "Please enter description" }]}
        >
          <Input.TextArea placeholder="Short bio" rows={3} />
        </Form.Item>

        <Form.Item label="Instagram" name={["socials", "instagram"]}>
          <Input placeholder="https://instagram.com/..." />
        </Form.Item>

        <Form.Item label="Facebook" name={["socials", "facebook"]}>
          <Input placeholder="https://facebook.com/..." />
        </Form.Item>

        <Form.Item label="LinkedIn" name={["socials", "linkedin"]}>
          <Input placeholder="https://linkedin.com/in/..." />
        </Form.Item>

        <Form.Item label="Twitter" name={["socials", "twitter"]}>
          <Input placeholder="https://twitter.com/..." />
        </Form.Item>
      </Form>
    </Modal>
  );
};

const AuthorManager = ({authors, setAuthors}) => {
  const [visible, setVisible] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null);
  const [editingAuthor, setEditingAuthor] = useState(null);

  const openAddModal = () => {
    setEditingIndex(null);
    setEditingAuthor(null);
    setVisible(true);
  };

  const openEditModal = (author, index) => {
    setEditingIndex(index);
    setEditingAuthor(author);
    setVisible(true);
  };

  const handleCreateOrUpdate = (authorData) => {
    const updatedAuthors = [...authors];
    if (editingIndex !== null) {
      updatedAuthors[editingIndex] = authorData;
    } else {
      updatedAuthors.push(authorData);
    }
    setAuthors(updatedAuthors);
    setVisible(false);
  };

  const deleteAuthor = (index) => {
    const updated = [...authors];
    updated.splice(index, 1);
    setAuthors(updated);
  };

  return (
    <div>
      <Button type="dashed" icon={<PlusOutlined />} onClick={openAddModal}>
        Add Author
      </Button>

      <AddEditAuthorModal
        visible={visible}
        onCreate={handleCreateOrUpdate}
        onCancel={() => setVisible(false)}
        initialValues={editingAuthor}
      />

      <List
        itemLayout="vertical"
        dataSource={authors}
        style={{ marginTop: 24 }}
        renderItem={(item, index) => (
          <Card
            style={{ marginBottom: 16 }}
            extra={
              <Space>
                {/* <Button
                  type="link"
                  icon={<EditOutlined />}
                  onClick={() => openEditModal(item, index)}
                >
                  Edit
                </Button> */}
                <Popconfirm
                  title="Are you sure to delete this author?"
                  onConfirm={() => deleteAuthor(index)}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button type="link" danger icon={<DeleteOutlined />}>
                    Delete
                  </Button>
                </Popconfirm>
              </Space>
            }
          >
            <List.Item>
              <List.Item.Meta
                avatar={
                  item.imageUrl ? <Avatar src={item.imageUrl} size={64} /> : null
                }
                title={item.name}
                description={item.description}
              />
              <div style={{ marginTop: 12 }}>
                {item.socials?.instagram && (
                  <div>
                    📸 Instagram:{" "}
                    <a href={item.socials.instagram} target="_blank" rel="noreferrer">
                      {item.socials.instagram}
                    </a>
                  </div>
                )}
                {item.socials?.facebook && (
                  <div>
                    📘 Facebook:{" "}
                    <a href={item.socials.facebook} target="_blank" rel="noreferrer">
                      {item.socials.facebook}
                    </a>
                  </div>
                )}
                {item.socials?.linkedin && (
                  <div>
                    💼 LinkedIn:{" "}
                    <a href={item.socials.linkedin} target="_blank" rel="noreferrer">
                      {item.socials.linkedin}
                    </a>
                  </div>
                )}
                {item.socials?.twitter && (
                  <div>
                    🐦 Twitter:{" "}
                    <a href={item.socials.twitter} target="_blank" rel="noreferrer">
                      {item.socials.twitter}
                    </a>
                  </div>
                )}
              </div>
            </List.Item>
          </Card>
        )}
      />
    </div>
  );
};



function CourseCreateForm() {


  const [selectedColor, setSelectedColor] = useState('#1890ff'); 
  const initialDefaultFields = [
      { label: 'Full Name', type: 'text', isDefault: true },
      { label: 'Email', type: 'text', isDefault: true, verifyWithOTP: false },
      { label: 'Mobile', type: 'number', isDefault: true, verifyWithOTP: false },
    ];

  const [formState, setFormState] = useState({
    title: '',
    coverMedia: null,
    description: '',
    cta: '',
    benefits: [],
    testimonials: [],
    faqs: [],
    gallery: [],
    authors: [],
    customSection: '',
    themeColor: selectedColor,
    modules:[],
    validity:{ type: 'lifetime', limitValue: 1, limitUnit: 'months' },
    pricing: { pricingType: 'fixed', regularPrice: 1000, offerPrice: 800, gstEnabled: false, minPrice: 200, suggestedPrice: 500 },
    fields:[...initialDefaultFields],
    coupons:[],
    policies: {
      terms: '',
      refund: '',
      privacy: '',
    }
  });


    const [selectedTab, setSelectedTab] = useState("1")
    const [uploadStatus, setUploadStatus] = useState(0)
    // Default
    const colorOptions = ["#000",'#4e95ff', '#26c92d', '#925eff', '#f5222d', '#ff51c2'];

    const defaultFields = [
        { label: 'Name', isDefault: true },
        { label: 'Email', isDefault: true },
        { label: 'Mobile', isDefault: true },
      ];

    const handleColorChange = (color) => {
      setSelectedColor(color);
      // TODO: Apply theme logic or save it
    };  

    const items = [
        {
          key: '1',
          label: 'Course Details',
          children: <div style={{paddingBottom:"20px"}}>
            <p>Course Title</p>
            <Input
              placeholder="Course Title"
              value={formState.title}
              onChange={(e) =>
                setFormState((prev) => ({ ...prev, title: e.target.value }))
              }
            />
            <p>Cover Image / Video</p>
            { formState.coverMedia  ? <img src={formState.coverMedia } width={"100%"} /> : <Upload
              beforeUpload={(file) => {
                
                return false;
              }}
              maxCount={1}
              onChange={({ file }) => {
                handleMediaUpload({file, "product_id":"some-id","uploadStatus":setUploadStatus, setURL: (url) => {setFormState((prev) => ({ ...prev, coverMedia: url }))}} ) }
            }
            > 
              <Button icon={<UploadOutlined />} block color="purple" variant="outlined">Upload Image / Video</Button>

            </Upload>
          }
            { (uploadStatus > 0 && uploadStatus < 100) && <Progress percent={uploadStatus}/> }


            <p>Description</p>
            <RichEditor
            data={formState.description}
            onChange={(value) =>
              setFormState((prev) => ({ ...prev, description: value }))
            }
            />

            <p>CTA button</p>

            <Input
              placeholder="Join Now"
              value={formState.cta}
              onChange={(e) =>
                setFormState((prev) => ({ ...prev, cta: e.target.value }))
              }
            />


            <Divider />

            <CourseBenefits benefits={formState.benefits} setBenefits={(benefits) => { setFormState((prev) => ({ ...prev, benefits: benefits })) }} />
            <TestimonialsSection testimonials={formState.testimonials} setTestimonials={(testimonials) => { setFormState((prev) => ({ ...prev, testimonials: testimonials })) }} />

            <FaqSection faqs={formState.faqs} setFaqs={(faqs) => { setFormState((prev) => ({ ...prev, faqs: faqs })) }} />

            {/* <p>Gallery</p> */}

            <p>About Author</p>
            <AuthorManager authors={formState.authors} setAuthors={(authors) => { setFormState((prev) => ({ ...prev, authors: authors })) }}/>

            <Button onClick={() => setSelectedTab("2")} color="default" variant="solid" block>Next Step : Content</Button>
          </div>,
        },
        {
          key: '2',
          label: 'Content & Pricing',
          children: <div style={{paddingBottom:"20px"}}>
            <CourseSyllabus modules={formState.modules} setModules={(modules) => { setFormState((prev) => ({ ...prev, modules: modules })) }} />
            <ValiditySelector validity={formState.validity} setValidity={(validity) => { setFormState((prev) => ({ ...prev, validity: validity })) }} />
            <PricingSection pricing={formState.pricing} setPricing={(pricing) => { setFormState((prev) => ({ ...prev, pricing: pricing })) }} />
            <Button style={{marginTop:"20px"}} onClick={() => setSelectedTab("3")} color="default" variant="solid" block>Next Step : Settings</Button>
          </div>,
        },
        {
          key: '3',
          label: 'Settings',
          children: <div style={{paddingBottom:"20px"}}>
                <div style={{ padding: '10px 0' }}>
                    <p style={{ marginBottom: 8 }}>Choose Theme Color:</p>
                        <div style={{display:"flex", flexDirection:"row", gap:"10px"}}>
                        {colorOptions.map((color) => 
                        <div
                            key={color}
                            value={color}
                            style={{
                            backgroundColor: color,
                            border: selectedColor === color ? '2px solid black' : 'none',
                            borderRadius: '50%',
                            marginRight: 10,
                            borderWidth: 2,
                            height:20,
                            width: 20,
                            cursor:"pointer"
                            }}
                            onClick={() => handleColorChange(color)}
                            >
                        </div>
                        
                    
                        )}
                        </div>
                </div>
            
            <div>
      
        </div>
            <StudentFieldsManager customFields={formState.fields} setCustomFields={(fields) => { setFormState((prev) => ({ ...prev, fields: fields })) }} />
            <DiscountCoupons coupons={formState.coupons} setCoupons={(coupons) => { setFormState((prev) => ({ ...prev, coupons: coupons })) }} />
            <PoliciesManager policies={formState.policies} setPolicies={(policies) => { setFormState((prev) => ({ ...prev, policies: policies })) }} />
            <Button onClick={()=>console.log(formState)} icon={<CheckCircleOutlined/>} style={{marginTop:"20px"}}  color="green" variant="solid" block>Create Course</Button>
          </div>
        },
      ];

    return (
        <div className="course-create-left-side">
            <Tabs activeKey={selectedTab}  onChange={(key) => setSelectedTab(key)} items={items}  />
        </div>
    );
}

function CoursePreview() {
    return (
        <div className="course-create-preview desktop">
            {/* Live preview UI here */}
        </div>
    );
}



export default function Courses() {

    const [messageApi, contextHolder] = message.useMessage();


    return (
        <div className="page-layout" style={{ backgroundImage: 'linear-gradient(180deg, #f4e9f9 0%, #e9f0fc 100%)' }}>

            {contextHolder}

            <Sider />

            <div className="page-content">

                <div className="page-header">
                    <p>Header</p>
                </div>

                <div>
                    <p>Dashboard</p>
                </div>
                <div>
                    <p>Course List</p>
                </div>
            </div>

            <Drawer style={{ overflowY: "hidden" }}

            extra={
            <div>
              <Button onClick={() => {}} style={{ marginRight: 8 }}>
                Cancel
              </Button>
              <Button type="primary" onClick={() => {}}>
                Save as Draft
              </Button>
            </div>
          }
            
            width={"100%"} open={true} title="Create New Course">
                <div className="course-create">

                    <CourseCreateForm />

                    <CoursePreview />
                    

                </div>

            </Drawer>
        </div>
    )
}